var map = {
	"./american_football/match.vue": "4dd5",
	"./badminton/match.vue": "0c05",
	"./baseball/match.vue": "6b1d",
	"./basketball/match.vue": "2872",
	"./cricket/match.vue": "e154",
	"./football/match.vue": "c6cc",
	"./handball/match.vue": "52bb",
	"./ice_hockey/match.vue": "dc5e",
	"./snooker/match.vue": "f70c",
	"./table_tennis/match.vue": "010a",
	"./tennis/match.vue": "b2c9",
	"./volleyball/match.vue": "61c7",
	"./waterpolo/match.vue": "4a7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85eb";